import { render, staticRenderFns } from "./SellerPage.vue?vue&type=template&id=6dbf9034&scoped=true"
import script from "./SellerPage.vue?vue&type=script&lang=js"
export * from "./SellerPage.vue?vue&type=script&lang=js"
import style0 from "./SellerPage.vue?vue&type=style&index=0&id=6dbf9034&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbf9034",
  null
  
)

export default component.exports